var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnopolis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 28.8",
    style: {
      enableBackground: "new 0 0 141.7 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    fill: "#D7352D",
    points: "130.7,20.4 130.7,22.6 135,22.6 135,27 137.2,27 137.2,20.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    fill: "#D7352D",
    points: "135.1,16 135.1,18.2 139.4,18.2 139.4,22.6 141.6,22.6 141.6,16  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M7.2,15.4c-0.6,0.5-1.6,0.9-2.4,0.9c-1.9,0-3.2-1.4-3.2-3.3V7H0V4.7h1.6V1.6h2.6v3.1V7v5.8     c0,0.8,0.5,1.3,1.1,1.3c0.5,0,0.9-0.2,1.1-0.4L7.2,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M18.7,12.8l1.7,1.7c-1,1-3,1.7-4.6,1.7c-3.2,0-5.9-2.5-5.9-5.9c0-3.4,2.5-5.9,5.8-5.9c3.5,0,5.5,2.6,5.5,6.8     h-8.5c0.3,1.6,1.5,2.6,3.1,2.6C16.8,14,18.1,13.5,18.7,12.8z M12.7,9.3h5.9c-0.3-1.4-1.3-2.4-2.9-2.4C14.3,6.8,13.1,7.8,12.7,9.3     z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M23.6,10.4c0-3.2,2.8-5.9,6.1-5.9c1.7,0,3.2,0.7,4.3,1.8l-1.8,1.6c-0.6-0.7-1.6-1.1-2.5-1.1     c-1.9,0-3.4,1.7-3.4,3.6c0,2,1.6,3.7,3.4,3.7c1,0,1.9-0.5,2.6-1.2l1.8,1.6c-1.1,1.2-2.6,1.9-4.4,1.9     C26.4,16.3,23.6,13.6,23.6,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M47.2,8.9v7.2h-2.6V9.4c0-1.5-1-2.6-2.4-2.6c-1.5,0-2.8,1.1-2.8,2.4v6.8h-2.7V0.8h2.7v5.5     c0.7-1.1,2-1.8,3.5-1.8C45.4,4.5,47.2,6.3,47.2,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M61.3,8.9v7.2h-2.6V9.4c0-1.5-1-2.6-2.4-2.6c-1.4,0-2.6,0.9-2.7,2.1v7.2h-2.7V4.7h2.7v1.5     c0.7-1,2-1.8,3.5-1.8C59.5,4.5,61.3,6.3,61.3,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M64.3,10.4c0-3.2,2.8-5.9,6.1-5.9s6.1,2.7,6.1,5.9c0,3.2-2.8,5.9-6.1,5.9S64.3,13.6,64.3,10.4z M73.8,10.4     c0-2-1.6-3.6-3.4-3.6c-1.9,0-3.5,1.7-3.5,3.6c0,2,1.6,3.7,3.5,3.7C72.3,14,73.8,12.4,73.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M91.4,10.4c0,3.5-2.2,5.9-5.2,5.9c-1.7,0-3-0.8-3.9-2.1v5.6h-2.7V4.7h2.7v1.8c0.9-1.3,2.3-2.1,3.9-2.1     C89.2,4.5,91.4,6.9,91.4,10.4z M88.8,10.4c0-2.1-1.4-3.6-3.3-3.6c-1.9,0-3.2,1.5-3.2,3.6s1.3,3.7,3.2,3.7     C87.4,14,88.8,12.5,88.8,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M94,10.4c0-3.2,2.8-5.9,6.1-5.9s6.1,2.7,6.1,5.9c0,3.2-2.8,5.9-6.1,5.9S94,13.6,94,10.4z M103.5,10.4     c0-2-1.6-3.6-3.4-3.6c-1.9,0-3.5,1.7-3.5,3.6c0,2,1.6,3.7,3.5,3.7C101.9,14,103.5,12.4,103.5,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M109.2,0.8h2.7v15.3h-2.7V0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M115.5,1.5c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S117.9,3,117.1,3C116.2,3,115.5,2.3,115.5,1.5z      M115.7,4.7h2.7v11.3h-2.7V4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M121.3,14.6l1.2-1.9c1.1,0.8,2.4,1.3,3.8,1.3c1.1,0,1.8-0.5,1.8-1.2c0-0.9-1-1.2-2.3-1.5     c-2.4-0.6-4-1.3-4-3.3c0-2.1,1.7-3.6,4.3-3.6c1.6,0,3.1,0.5,4.3,1.4l-1.1,1.9c-1.1-0.7-2.2-1-3.2-1c-0.9,0-1.7,0.4-1.7,1     c0,0.7,0.6,0.9,2.3,1.4c1.9,0.5,4,1.2,4,3.5c0,2.2-1.8,3.6-4.4,3.6C124.5,16.3,122.7,15.7,121.3,14.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#D7352D",
    d: "M5.7,5.8c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S8.1,7.3,7.2,7.3C6.4,7.3,5.7,6.6,5.7,5.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M107.6,22.6v3.9c0,1.1-0.9,1.9-2.2,1.9c-0.7,0-1.4-0.2-1.8-0.6l0.3-0.6c0.3,0.3,0.8,0.5,1.4,0.5    c0.9,0,1.5-0.4,1.5-1.2v-0.6c-0.3,0.5-0.9,0.8-1.5,0.8c-1.1,0-2-0.9-2-2.1c0-1.2,0.8-2,2-2c0.7,0,1.2,0.3,1.5,0.8v-0.7H107.6z     M106.8,24.6c0-0.8-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3c0,0.8,0.5,1.3,1.3,1.3S106.8,25.4,106.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M111.3,22.5v0.7c-0.9,0-1.5,0.5-1.6,1.2v2.5h-0.8v-4.3h0.8v0.8C109.9,22.9,110.5,22.5,111.3,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M111.6,24.8c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3c0,1.2-1,2.3-2.3,2.3C112.7,27,111.6,26,111.6,24.8z     M115.3,24.8c0-0.8-0.7-1.5-1.4-1.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5C114.7,26.3,115.3,25.6,115.3,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M120.9,22.6v4.3H120v-0.6c-0.3,0.4-0.8,0.7-1.4,0.7c-1,0-1.6-0.7-1.6-1.7v-2.8h0.8v2.6c0,0.6,0.4,1.1,1,1.1    c0.6,0,1.1-0.4,1.2-0.9v-2.8H120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#130E09",
    d: "M126.4,24.8c0,1.3-0.9,2.3-2,2.3c-0.7,0-1.2-0.3-1.5-0.9v2.2H122v-5.8h0.8v0.7c0.3-0.5,0.9-0.8,1.5-0.8    C125.5,22.5,126.4,23.5,126.4,24.8z M125.5,24.8c0-0.9-0.6-1.5-1.4-1.5c-0.8,0-1.3,0.6-1.3,1.5c0,0.9,0.6,1.5,1.3,1.5    C125,26.3,125.5,25.7,125.5,24.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnopolis);
export default __webpack_public_path__ + "static/media/technopolis.3b404c2bb71591ff90e2b541ba385d4c.svg";
export { ForwardRef as ReactComponent };